import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { ApiLoader } from '@/components/ui/api-loader';
import { toast } from 'sonner';
import { useLoginMutation } from '@/hooks/mutations/useLoginMutation';

interface AuthPageProps {
  mode: 'login' | 'signup';
  onSuccess: (token?: string) => void;
}

export function AuthPage({ mode, onSuccess }: AuthPageProps) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const loginMutation = useLoginMutation();

  const isSignup = mode === 'signup';

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (isSignup) {
      toast.info('Signup API is not integrated yet. Logged in as demo user.');
      onSuccess();
      return;
    }

    try {
      const result = await loginMutation.mutateAsync({
        email: email.trim(),
        password,
      });
      toast.success('Login successful.');
      onSuccess(result.token);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Unable to login.';
      toast.error(message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/20 p-4">
      <Card className="relative w-full max-w-md">
        {/* <ApiLoader show={loginMutation.isPending && !isSignup} text="Signing you in..." overlay /> */}
        <CardHeader>
          <CardTitle>{isSignup ? 'Create your account' : 'Welcome back'}</CardTitle>
          <CardDescription>
            {isSignup
              ? 'Sign up to access the LocalFirst admin panel.'
              : 'Log in to continue to the LocalFirst admin panel.'}
          </CardDescription>
        </CardHeader>

        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {isSignup && (
              <div className="space-y-2">
                <Label htmlFor="name">Name</Label>
                <Input
                  id="name"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                  placeholder="Your name"
                  required
                />
              </div>
            )}

            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="you@example.com"
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="********"
                minLength={4}
                required
              />
            </div>

            <Button type="submit" className="w-full" disabled={loginMutation.isPending}>
              {isSignup ? 'Create Account' : 'Login'}
            </Button>
          </form>

          {/* <p className="text-sm text-muted-foreground mt-4">
            {isSignup ? 'Already have an account?' : "Don't have an account?"}{' '}
            <Link to={isSignup ? '/login' : '/signup'}>
              <span className="text-primary cursor-pointer hover:underline">
                {isSignup ? 'Login' : 'Sign up'}
              </span>
            </Link>
          </p> */}
        </CardContent>
      </Card>
    </div>
  );
}
